module.exports = __webpack_public_path__ + "static/in-app-trading-gif-a6b45110f04ed6f2cc239bdc8ff4e75b.gif";